import { BUILDING_LOCKED_TOOLTIP_POSITION } from '@/map-phaser-new/constants'
import type { BuildingConfigInterface } from '@/map-phaser-new/interfaces'

export const clubConfig: BuildingConfigInterface = {
  textureKey: 'buildings',
  frameKey: 'club',
  routeConfig: {
    routeName: 'ClubsAvailable',
    routeNameForClubMembership: 'ClubsMap',
    soundName: 'click-map-artefact',
    isRouteParamIdNeeded: false,
  },
  positionX: 2508,
  positionY: 578,
  depth: 4,
  originX: 0,
  keyForTranslateTitle: 'map.clubName',
  buildingTitleConfig: {
    positionX: 2706,
    positionY: 844.5,
    depth: 7,
    textConfig: {
      originX: 0.5,
      positionX: 20,
      fontName: 'Nunito Sans',
      fontSize: '24px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontColor: '#fff',
    },
    backgroundImageConfig: {
      textureName: 'common',
      frameNameRightSide: 'right_side',
      frameNameRightSideLocked: 'right_side_locked',
      frameNameLeftSide: 'left_side',
      frameNameLeftSideLocked: 'left_side_locked',
      originX: 0.5,
      positionX: 60,
      widthCorrection: 100,
      heightCorrection: 10,
    },
  },
  outlineConfig: {
    framePostFix: '_outline',
    depth: 6,
    originX: 0,
    positionByLevel: {
      '1': { positionX: 2508, positionY: 578 },
      '2': { positionX: 2508, positionY: 578 },
      '3': { positionX: 2508, positionY: 578 },
      '4': { positionX: 2508, positionY: 578 },
    },
    textureKey: 'buildingsOutlines',
  },
  inputConfig: {
    useHandCursor: true,
  },
  buildingLockedConfig: {
    textureKey: 'lockedBuildings',
    framePostfix: '_locked',
    positionX: 2688,
    positionY: 728.5,
    lockImageTextureKey: 'lock',
    lockImageDepth: 6,
    depth: 5,
    tooltipConfig: {
      tooltipPosition: BUILDING_LOCKED_TOOLTIP_POSITION.Top,
      tooltipTextureHeight: '213px',
      tooltipTextureWidth: '444px',
      depth: 10,
      titleConfig: {
        originX: 0.5,
        fontSize: '30px',
        fontName: 'Nunito Sans',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontColor: '#fff',
      },
      subtitleConfig: {
        originX: 0.5,
        originY: 0.5,
        fontName: 'Nunito Sans',
        fontSize: '24px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontColor: '#fff',
        replaceFontColor: '#fec742',
        tooltipSubtitleTranslateKey: 'common.mainCareerTaskRequired',
        tooltipSubtitleReplaceFlag: '%s',
      },
      tooltipHideDelay: 2000,
      tooltipLeftTextureName: 'building_tooltip_left',
      tooltipRightTextureName: 'building_tooltip_right',
      tooltipTopTextureName: 'building_tooltip_top',
    },
  },
}
